import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {CLEAR_ALERT} from "@/actions/types";

function Alerter() {
  const navigate = useNavigate();
  const alerter = useSelector((state: any) => state.alert.message);
  const dispatch = useDispatch();

  useEffect(() => {
    if(!alerter)
      return;
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      icon: alerter.result ? "success" : "error",
      title: <p>{alerter.result ? "عملیات موفق" : "عملیات ناموفق"}</p>,
      html: <p>{alerter.message || (alerter.result ? "عملیات با موفقیت انجام پذیرفت!" : "انجام عملیات ناموفق بود")}</p>
    }).then(() => {
      if(alerter.url) {
        if(alerter.external)
          document.location.href = alerter.url;
        else navigate(alerter.url);
      }
      dispatch({
        type: CLEAR_ALERT
      });
    });
  }, [alerter]);

  return <></>;
}

export default Alerter;
